import React, { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getIsAuthFailedOrder, getMutationInProgress, getSelectedOrder } from '../../selectors/order'
import { isTabbed } from '../../utils/orderStates'
import RoundButton from '../../components/RoundButton'
import { getBackbarMode, getNetworkAvailable } from '../../selectors/config'
import { getIsKiosk } from '../../selectors/menus'
import AddTipAndFinalizeModals from './AddTipAndFinalizeModals'
import usePrinter from '../../VNPrinters/hooks/usePrinter'
import { setConnectionRequiredDialog } from '../../VNDialogs/ActionCreators'

const BackBarButtons = ({ className }) => {
  const dispatch = useDispatch()
  const order = useSelector(getSelectedOrder)
  const isKiosk = useSelector(getIsKiosk)
  const isTab = isTabbed(order)
  const isBackBar = useSelector(getBackbarMode)
  const mutationInProgress = useSelector(getMutationInProgress)
  const isAuthFailedTab = useSelector(getIsAuthFailedOrder)
  const [showTipAndFinalize, setShowTipAndFinalize] = useState(false)
  const { printSlipHandler, printCheckHandler } = usePrinter()
  const networkConnected = useSelector(getNetworkAvailable)

  const shouldRender = useMemo(() => {
    if (!isBackBar) return false
    if (isKiosk) return false
    if (!isTab && !isAuthFailedTab) return false

    return true
  }, [isKiosk, isTab, isBackBar, isAuthFailedTab])

  const finalizeHandler = useCallback(() => {
    // we were online and are trying to modify order while offline
    if (!networkConnected && order?.wasCreatedInStadium) {
      dispatch(setConnectionRequiredDialog(true))
      return
    }

    setShowTipAndFinalize(true)
  }, [dispatch, networkConnected, order?.wasCreatedInStadium])

  if (!shouldRender) {
    return null
  }

  return (
    <>
      <AddTipAndFinalizeModals showTipAndFinalize={showTipAndFinalize} setShowTipAndFinalize={setShowTipAndFinalize} />
      <div>
        <RoundButton className={className} text="Print Check" onClick={printCheckHandler} disabled={mutationInProgress} />
        <RoundButton text="Print Slip" className={className} onClick={printSlipHandler} disabled={mutationInProgress} />
        <RoundButton className={className} text="Add Tip & Finalize" onClick={finalizeHandler} disabled={mutationInProgress} />
      </div>
    </>
  )
}

export default BackBarButtons
